import { cn } from '@/true-fsd/shared/utils/css'

/**
 * Пропсы для иконки выравнивания по центру
 */
export interface AlignmentCenterIconProps {
    /**
     * Дополнительные CSS классы
     */
    className?: string
}

/**
 * Иконка выравнивания текста по центру
 */
export function AlignmentCenterIcon({ className }: AlignmentCenterIconProps) {
    return (
        <svg
            width="15"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4 6H19M6.5 10H16.5M4 14H19M6.5 18H16.5"
                stroke="#94A6AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
